import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyAttendance = Loadable({
    loader: () => import("pages/Attendance/index"),
    loading: () => <PageLoader />,
});


function AttendanceRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyAttendance />} />
            {/* <Route path="/detail/:order_id" element={<LazyOrderDetail />} /> */}
        </Routes>
    );
}

export default AttendanceRoute;
